export default "__VITE_ASSET__15cbf959__"